import { toast } from "react-toastify";
import {
  CONSTANTS,
  encryptValue,
  getChannelName,
  getFlagName,
  saveInLocalStorage,
  titleCase,
} from "../../utilFunctions";
import TextTruncate from "../../utilsComponent/textTruncate";
import { format, formatDistance } from "date-fns";
import { getCalamityNames } from "../apiHelper.js";
import ViewMoreLess from "../../reusableComponents/ViewMoreLess.jsx";
import NoDataFound from "../../utilsComponent/noDataFound.jsx";
import ReactPaginate from "react-paginate";
import Colors from "../../utilsComponent/colors.jsx";
import Form from "react-bootstrap/Form";
import { AREA_BASED, INDIVIDUAL } from "../../consts.js";
import { fetchPolicySearch } from "./apiHelper.js";

const MyWorkItemsSearch = (props) => {
  const {
    claimslist,
    loading,
    setLoading,
    getClaimDetails,
    portalList,
    setItemsPerPage,
    setSelectedPage,
    itemsPerPage,
    pageCount,
    selectedPage,
    triggerAPi,
    setTriggerAPi,
  } = props;

  const policySearch = async (
    policyNumber,
    farmerID,
    claimNumber,
    productName,
    productID,
    claim
  ) => {
    let payload = {
      searchType:
        policyNumber !== null
          ? CONSTANTS.SEARCH_TYPE_POLICY_NUMBER
          : CONSTANTS.SEARCH_TYPE_TRANSACTION,
      product: productName,
      searchValue: policyNumber !== null ? policyNumber : claim?.policy?.tranId,
    };
    const data = await fetchPolicySearch(payload, setLoading)
    if (!policyNumber) {
      if (data?.data?.length > 0) {
        let policyDetailsEncripted = encryptValue(
          JSON.stringify(data.data[0])
        );
        saveInLocalStorage("policyDetail", policyDetailsEncripted);
        getClaimDetails(claimNumber, true);
      } else {
        toast.error("Unable to Fetch Policy Details.");
      }
    } else {
      if (
        data?.data &&
        data?.data !== "No Data Present" &&
        data?.data?.length > 0
      ) {
        let policyDetailsEncripted = encryptValue(
          JSON.stringify(data.data[0])
        );
        saveInLocalStorage("policyDetail", policyDetailsEncripted);
        getClaimDetails(claimNumber, true);
      } else {
        toast.error("Unable to Fetch Policy Details.");
      }
    }
  };

  const findPortalName = (portalCode) => {
    const selectedValue = portalList.find((option) => option.id === portalCode);
    return selectedValue?.name;
  };
  const itemPerChangeHandler = (count) => {
    setItemsPerPage(count);
    setSelectedPage(1);
    setTriggerAPi(!triggerAPi);
  };
  const handlePageClick = (event) => {
    setSelectedPage(event.selected + 1);
    setTriggerAPi(!triggerAPi);
  };

  return (
    <div className={`${claimslist?.length > 0 && "overflowclaim"}`}>
      {!loading && claimslist?.length > 0 ? (
        <table id="claim_historyclaim">
          <tbody>
            <tr>
              <th>Claim Number</th>
              <th>Policy Number</th>
              <th>Transaction ID</th>
              <th>Claim Created By</th>
              <th>Claim Intimated By</th>
              <th>Farmer Name</th>
              <th>Source</th>
              <th>Product Name</th>
              <th>Intimated Date & time</th>
              <th>Contact Number</th>
              <th>Date & time of Peril Occurrence</th>
              <th>Status</th>
              <th className="centerclaim">Sub Status</th>
              <th>Crop</th>
              <th>Peril Type</th>
              <th>Claim Ingestion Type</th>
              <th>Calamity Type</th>
              <th>Season</th>
              <th>Year</th>
              <th>Policy Status</th>
              <th>Vendor Name</th>
              <th>Surveyor Name</th>
              <th>State</th>
              <th>District</th>
              <th className="field-alignment">GIS Remarks</th>
              <th>GIS Status</th>
              <th>Survey Aging</th>
              <th>Survey Status</th>
              <th>QC Aging</th>
              <th>QC Status</th>
              <th>Assigned to</th>
              <th>Role</th>
              <th>Category</th>
              <th>Flagged Claims</th>
            </tr>
            {claimslist &&
              claimslist?.length > 0 &&
              claimslist.map((claimlist) => (
                <tr>
                  <td>
                    <span
                      className="text-primary"
                      onClick={() => {
                        policySearch(
                          claimlist?.policy?.policyNumber,
                          claimlist?.policy?.custemerID,
                          claimlist?.claimNo,
                          claimlist?.productName,
                          claimlist?.productID,
                          claimlist
                        );
                      }}
                    >
                      {claimlist?.claimNo ? (
                        <TextTruncate text={claimlist.claimNo} length={22} />
                      ) : (
                        "--"
                      )}
                    </span>
                  </td>
                  <td className="policy_number">
                    {claimlist?.policy?.policyNumber}
                  </td>
                  <td>{claimlist?.policy?.tranId || "--"}</td>
                  <td>{claimlist?.createdBy || "--"}</td>
                  <td>{claimlist?.claimIntimatedBy || "--"}</td>
                  <td>{claimlist?.policy?.custmerName}</td>
                  <td>
                    {claimlist.channelID !== 11
                      ? getChannelName(claimlist?.channelID)
                      : findPortalName(claimlist?.portalCode)}
                  </td>
                  <td className="">
                    {claimlist?.productName ? claimlist?.productName : "--"}
                  </td>
                  <td className="">
                    {format(
                      new Date(claimlist?.claimOpenDate),
                      "dd-MM-yyyy, hh:mm a"
                    )}
                  </td>
                  <td className="">
                    {claimlist?.policy?.mobileNumber
                      ? claimlist?.policy?.mobileNumber
                      : "--"}
                  </td>
                  <td>
                    {claimlist?.dateAndTimeOfLoss
                      ? format(
                          new Date(claimlist?.dateAndTimeOfLoss.split(".")[0]),
                          "dd-MM-yyyy, hh:mm a"
                        )
                      : "--"}
                  </td>
                  <td className="inactive">
                    {claimlist?.claimStatus ? (
                      <Colors status={claimlist?.claimStatus} />
                    ) : (
                      "--"
                    )}
                  </td>
                  <td className="text-danger">
                    {claimlist?.claimSubstatus ? (
                      <Colors status={claimlist?.claimSubstatus} />
                    ) : (
                      "--"
                    )}
                  </td>
                  <td>
                    {claimlist?.riskName ? (
                      <TextTruncate text={claimlist?.riskName} length={10} />
                    ) : (
                      "--"
                    )}
                  </td>
                  <td>
                    {claimlist?.perilName ? (
                      <TextTruncate text={claimlist?.perilName} length={25} />
                    ) : (
                      "--"
                    )}
                  </td>
                  <td>
                    {claimlist?.claimIngestionType === INDIVIDUAL
                      ? "Individual"
                      : claimlist?.claimIngestionType === AREA_BASED
                      ? "Area Based"
                      : "--"}
                  </td>
                  <td>
                    {claimlist?.productType
                      ? getCalamityNames(claimlist?.productType)
                      : ""}
                  </td>
                  <td>
                    {claimlist?.policy?.seasonName
                      ? claimlist?.policy?.seasonName
                      : ""}
                  </td>
                  <td>
                    {claimlist?.policy?.seasonYear
                      ? claimlist?.policy?.seasonYear
                      : ""}
                  </td>
                  <td>
                    {claimlist?.policy?.status
                      ? titleCase(claimlist?.policy?.status)
                      : "--"}
                  </td>
                  <td>{claimlist?.vendor ? claimlist?.vendor : ""}</td>
                  <td>
                    {claimlist?.surveyor ? (
                      <TextTruncate
                        text={`${claimlist?.surveyor.replace(" null", "")} ${
                          claimlist?.surveyor.includes(
                            claimlist?.surveyorMobileNumber
                          )
                            ? ""
                            : claimlist?.surveyorMobileNumber
                        }`}
                        length={20}
                      />
                    ) : (
                      ""
                    )}
                  </td>
                  <td className="">{claimlist?.policy?.state}</td>
                  <td className="">{claimlist?.policy?.district}</td>
                  <td>
                    {claimlist?.gisRemarks ? (
                      <ViewMoreLess
                        text={claimlist?.gisRemarks}
                        truncateLength={13}
                      />
                    ) : (
                      "--"
                    )}
                  </td>
                  <td>{claimlist?.gisSurvey}</td>
                  <td>
                    {claimlist?.surveyInitiatedDate
                      ? claimlist?.surveyReceivedDate
                        ? formatDistance(
                            new Date(claimlist?.surveyInitiatedDate),
                            new Date(claimlist?.surveyReceivedDate)
                          )
                        : formatDistance(
                            new Date(claimlist?.surveyInitiatedDate),
                            new Date()
                          )
                      : ""}
                  </td>
                  <td>{claimlist?.fieldSurvey}</td>
                  <td>
                    {claimlist?.qcinitiatedDate
                      ? claimlist?.qcclosedDate
                        ? formatDistance(
                            new Date(claimlist?.qcinitiatedDate),
                            new Date(claimlist?.qcclosedDate)
                          )
                        : formatDistance(
                            new Date(claimlist?.qcinitiatedDate),
                            new Date()
                          )
                      : ""}
                  </td>
                  <td>{claimlist?.qcStatus}</td>
                  <td>{claimlist?.assignedTo ? claimlist?.assignedTo : "--"}</td>
                  <td>{claimlist?.role ? claimlist?.role : "--"}</td>
                  <td>
                    {claimlist?.category ? (
                      <TextTruncate text={claimlist?.category} length={15} />
                    ) : (
                      "--"
                    )}
                  </td>
                  <td>{getFlagName(claimlist?.flags)}</td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <NoDataFound text={"No data Found"} />
      )}
      {claimslist && claimslist?.length > 0 && (
        <div className="d-flex align-items-center justify-content-end">
          <div className="d-flex">
            Select Limit :
            <Form className="ms-3">
              <div className="mb-0 d-flex align-items-center">
                {/* 10 */}
                <Form.Check inline name="page-size" id="page-size-10">
                  <Form.Check.Input
                    type="radio"
                    style={{ cursor: "pointer" }}
                    checked={itemsPerPage === 10}
                    onChange={() => itemPerChangeHandler(10)}
                  />
                  <Form.Check.Label>10</Form.Check.Label>
                </Form.Check>

                {/* 25 */}
                <Form.Check inline name="page-size" id="page-size-25">
                  <Form.Check.Input
                    type="radio"
                    style={{ cursor: "pointer" }}
                    checked={itemsPerPage === 25}
                    onChange={() => itemPerChangeHandler(25)}
                  />
                  <Form.Check.Label>25</Form.Check.Label>
                </Form.Check>

                {/* 50 */}
                <Form.Check inline name="page-size" id="page-size-50">
                  <Form.Check.Input
                    type="radio"
                    style={{ cursor: "pointer" }}
                    checked={itemsPerPage === 50}
                    onChange={() => itemPerChangeHandler(50)}
                  />
                  <Form.Check.Label>50</Form.Check.Label>
                </Form.Check>
              </div>
            </Form>
          </div>
          <ReactPaginate
            nextLabel=">>"
            onPageChange={(e) => handlePageClick(e)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            forcePage={selectedPage - 1}
            previousLabel="<<"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </div>
      )}
    </div>
  );
};

export default MyWorkItemsSearch;
